import React from "react";
import "../loading.scss";

export const LoadingImg = () => {
  return <div className="loading loading-img" />;
};
